import { JobPosition } from '../types';

export const jobPositionsBySegment: Record<string, JobPosition[]> = {
  大手事業会社: [],
  メガベンチャー: [],
  SIer: [],
  コンサル: []
};

export const jobPositionList: JobPosition[] = [
  {
    id: 1,
    segment: '大手事業会社',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1146.png',
    company: 'ソフトバンク',
    position: 'クラウドエンジニア',
    salary: '600〜1300万円',
    description:
      'ソフトバンク全領域へIaaS/PaaS共通クラウド基盤の企画設計開発運用支援'
  },
  {
    id: 2,
    segment: '大手事業会社',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/4757.png',
    company: 'リクルート',
    position: 'プロダクト開発\nディレクター',
    salary: '662〜957万円',
    description:
      'じゃらんnet中心旅行サービスにおける戦略立案・開発・運用管理および分析統括'
  },
  {
    id: 3,
    segment: '大手事業会社',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1241.png',
    company: 'ベネッセ',
    position: 'AIエンジニア・データサイエンティスト',
    salary: '850〜1660万円',
    description:
      'ベネッセグループ各事業におけるデータ解析とAI技術でサービス進化と社会変革実現'
  },
  {
    id: 4,
    segment: '大手事業会社',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1036.png',
    company: 'パナソニック',
    position: '基幹業務系\nエンジニア',
    salary: '650〜850万円',
    description:
      '一般市場向けERP基幹システムの企画・提案・導入・保守支援及び全体最適化業務'
  },
  {
    id: 5,
    segment: '大手事業会社',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1148.png',
    company: 'KDDI',
    position: 'システム・\nITアーキテクト',
    salary: '応相談',
    description:
      'データ活用促進を担うKDDIビジネス支援の次世代情報基盤設計・構築及び運用業務'
  },
  {
    id: 6,
    segment: '大手事業会社',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/649.png',
    company: '三井住友銀行',
    position: 'セキュリティエンジニア',
    salary: '応相談',
    description:
      'クラウドセキュリティ高度化の企画、監視運用、事故対応及び監査支援と専門助言含む'
  },
  {
    id: 7,
    segment: '大手事業会社',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/3155.png',
    company: 'パソナグループ',
    position: 'システムエンジニア',
    salary: '500〜1500万円',
    description:
      '社内のDX推進や環境構築を支援、基幹システム開発・ITインフラ整備を担当'
  },
  {
    id: 8,
    segment: '大手事業会社',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/702.png',
    company: 'SBI証券',
    position: 'サーバーサイドエンジニア',
    salary: '600〜800万円',
    description:
      '大規模個人投資家支持スマホ金融アプリを支える安定低遅延高性能サーバー構築・運用'
  },
  {
    id: 9,
    segment: '大手事業会社',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/667.png',
    company: 'オリックス',
    position: 'DXエンジニア',
    salary: '600〜1100万円',
    description:
      'AWS基盤上でSaaS製品の企画開発および運用保守と多部署連携による業務改革推進'
  },
  {
    id: 10,
    segment: '大手事業会社',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1029.png',
    company: 'キーエンス',
    position: '社内SE',
    salary: '応相談',
    description:
      'キーエンス全体のIT基盤運営、課題抽出から改善企画設計・構築及び海外支援担当'
  },
  {
    id: 11,
    segment: '大手事業会社',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1125.png',
    company: '富士フィルム',
    position: 'マルチモーダルAI開発',
    salary: '500〜1000万円',
    description:
      '多様な画像・言語・数値データを活用し実生活課題解決へ向けた深層学習AI研究開発'
  },
  {
    id: 12,
    segment: '大手事業会社',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/873.png',
    company: 'ミスミ',
    position: 'フロントエンド\nエンジニア',
    salary: '500〜900万円',
    description:
      '新規プロダクトにおけるフロントエンド実装・再設計及び組織整備と人材育成の総合推進'
  },
  {
    id: 13,
    segment: 'メガベンチャー',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/271.png',
    company: 'サイバーエージェント',
    position: 'サーバーサイド\nエンジニア',
    salary: '500〜800万円',
    description:
      'スマートフォンゲーム向けAPI、管理画面連動のサーバ構築、CS調査・インフラ対応業務'
  },
  {
    id: 14,
    segment: 'メガベンチャー',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1260.png',
    company: 'DeNA',
    position: 'プロジェクトマネージャー',
    salary: '応相談',
    description:
      '社内及び外部と連携しAI活用案件の発見、課題整理から実行管理まで総括指揮体制'
  },
  {
    id: 15,
    segment: 'メガベンチャー',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/542.png',
    company: '楽天',
    position: 'フロントエンド\nエンジニア',
    salary: '応相談',
    description:
      '楽天経済圏拡大へ向けたフロントエンド設計・実装およびAPI連携基盤整備の推進'
  },
  {
    id: 16,
    segment: 'メガベンチャー',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1005.png',
    company: 'メルカリ',
    position: 'プロダクトマネージャー',
    salary: '応相談',
    description:
      'MercariHalloを展開するHR領域新規事業の企画運営管理推進策の戦略'
  },
  {
    id: 17,
    segment: 'メガベンチャー',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/945.png',
    company: 'エムスリー',
    position: 'ネイティブアプリ\nエンジニア',
    salary: '500万円〜',
    description:
      '医療革新に貢献すべく、複数iOSアプリの企画・開発および運用と技術選定を担う職務'
  },
  {
    id: 18,
    segment: 'メガベンチャー',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/26827.png',
    company: 'タイミー',
    position: 'データサイエンティスト',
    salary: '700〜1000万円',
    description:
      '社内各領域と連携し確実な課題定義から解析・改善策定及び実証実験推進のデータ業務'
  },
  {
    id: 19,
    segment: 'メガベンチャー',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/28200.png',
    company: 'SmartHR',
    position: 'WEBアプリケーションエンジニア',
    salary: '546万円〜',
    description:
      '企画・設計から実装・自動試験、運用までSaaS全開発領域を横断するプロジェクト'
  },
  {
    id: 20,
    segment: 'メガベンチャー',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/999.png',
    company: 'GMO',
    position: 'データベースエンジニア',
    salary: '580〜940万円',
    description:
      '決済サービスの中核システムとして、データベース基盤の企画・構築・運用を担う業務'
  },
  {
    id: 21,
    segment: 'メガベンチャー',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/20734.png',
    company: 'freee',
    position: 'QAエンジニア',
    salary: '応相談',
    description:
      'freeeサービスの製品品質維持と向上をテスト計画・実施と欠陥解析により徹底推進'
  },
  {
    id: 22,
    segment: 'メガベンチャー',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1025.png',
    company: 'DMM',
    position: 'サーバーサイドエンジニア',
    salary: '600〜1200万円',
    description:
      'DMM各種サービスを支える決済基盤の安定運用と新規開発によるシステム改革促進'
  },
  {
    id: 23,
    segment: 'メガベンチャー',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1019.png',
    company: 'Sansan',
    position: 'WEBアプリ開発エンジニア',
    salary: '714〜1449万円',
    description:
      'Bill OneのWebアプリ開発全体工程に参画し迅速高品質なサービス実現への貢献'
  },
  {
    id: 24,
    segment: 'メガベンチャー',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1000.png',
    company: 'MIXI',
    position: 'SRE',
    salary: '500〜1060万円',
    description:
      'モンストサーバーの各種ミドルウェア検証とクラウド移行推進による運用最適化SRE業務'
  },
  {
    id: 25,
    segment: 'SIer',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1192.png',
    company: 'NTTデータ',
    position: 'システムエンジニア',
    salary: '450〜900万円',
    description:
      'メガバンク向けシステム開発の企画提案、要件整理と推進、新技術採用と横展開による革新'
  },
  {
    id: 26,
    segment: 'SIer',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/31.png',
    company: '野村総研',
    position: 'DXコンサルタント',
    salary: '応相談',
    description:
      '企業や官公庁の経営、業務、組織課題にデジタル技術活用で課題抽出から実装伴走支援'
  },
  {
    id: 27,
    segment: 'SIer',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1049.png',
    company: '富士通',
    position: 'プロジェクトマネージャー',
    salary: '応相談',
    description:
      'メガバンク法人向けインターネット改修プロジェクトの統括管理及びデリバリ革新推進'
  },
  {
    id: 28,
    segment: 'SIer',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1033.png',
    company: '日立',
    position: 'クラウドエンジニア',
    salary: '730〜970万円',
    description:
      'パブリック・プライベート各種クラウドで案件獲得とチーム統括により事業推進管理業務'
  },
  {
    id: 29,
    segment: 'SIer',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/1178.png',
    company: 'NEC',
    position: 'プロジェクトマネージャー',
    salary: '680〜800万円',
    description:
      '大手信託銀行向け個人顧客アプリの企画立案から開発・保守運用に至る全工程管理体制'
  },
  {
    id: 30,
    segment: 'SIer',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/595.png',
    company: '伊藤忠テクノソリューションズ',
    position: 'システムエンジニア',
    salary: '応相談',
    description:
      '海外最新技術を活かした顧客向けアプリ開発およびソリューション提案・全体管理体制'
  },
  {
    id: 31,
    segment: 'SIer',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/20.png',
    company: 'ベイカレントテクノロジー',
    position: 'システムエンジニア',
    salary: '600〜2000万円',
    description:
      '大手企業のIT課題を解決すべく各段階でシステム開発・運用支援を担うエンジニア職務'
  },
  {
    id: 32,
    segment: 'SIer',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/621.png',
    company: '大塚商会',
    position: 'アプリケーション\nエンジニア',
    salary: '応相談',
    description:
      '販売管理・会計・人事給与等の基幹システム上流工程と導入保守提案連携体制統括管理'
  },
  {
    id: 33,
    segment: 'SIer',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/2535.png',
    company: 'SBテクノロジー',
    position: 'AIコンサルタント',
    salary: '応相談',
    description:
      '企業向け機械学習システムの要件定義から試験評価、提案支援及び自社サービス企画担当'
  },
  {
    id: 34,
    segment: 'SIer',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/34.png',
    company: '日本総研',
    position: 'インフラエンジニア',
    salary: '応相談',
    description:
      'SMBCグループ大規模OA基盤における企画設計開発運用管理並び最新技術導入業務'
  },
  {
    id: 35,
    segment: 'SIer',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/16824.png',
    company: 'Works Human Intelligence',
    position: 'プロダクト開発\nエンジニア',
    salary: '500〜1100万円',
    description:
      '自社製品『COMPANY』の企画開発保守と新規サービス構築、既存機能強化の業務'
  },
  {
    id: 36,
    segment: 'SIer',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/2783.png',
    company: 'トヨタシステムズ',
    position: 'セキュリティエンジニア',
    salary: '650〜900万円',
    description:
      'トヨタ自動車等グループのセキュリティ構想、企画、導入及び東京地区顧客対応業務'
  },
  {
    id: 37,
    segment: 'コンサル',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/2984.png',
    company: 'ボストン・コンサルティング・グループ',
    position: '経営コンサルタント',
    salary: '610万円万円〜',
    description:
      '企業の経営課題に対する成長促進のため、デジタル戦略及びIT改革推進の中心役割'
  },
  {
    id: 38,
    segment: 'コンサル',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/13.png',
    company: 'デロイトトーマツコンサルティング',
    position: 'テクノロジー戦略\nコンサルタント',
    salary: '応相談',
    description:
      '経営層のデジタル課題に、革新的戦略と組織改革で応えるコンサルティング業務全般'
  },
  {
    id: 39,
    segment: 'コンサル',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/12.png',
    company: 'PwCコンサルティング',
    position: 'ITコンサルタント',
    salary: '応相談',
    description:
      'クライアントの経営戦略に沿い、デジタル技術活用による実行計画と評価指標の策定'
  },
  {
    id: 40,
    segment: 'コンサル',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/3197.png',
    company: 'EYストラテジー・アンド・コンサルティング',
    position: 'DXコンサルタント',
    salary: '応相談',
    description:
      'クライアントのDX変革実現のため戦略策定から実行支援、技術導入支援、組織改革支援'
  },
  {
    id: 41,
    segment: 'コンサル',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/22.png',
    company: 'KPMGコンサルティング',
    position: 'ITコンサルタント',
    salary: '595万円〜',
    description:
      '公共機関を含む各企業の事業改革及び業務・組織改革と全体最適実現に向けたIT戦略支援'
  },
  {
    id: 42,
    segment: 'コンサル',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/14.png',
    company: 'アビームコンサルティング',
    position: 'コンサルタント',
    salary: '580〜2000万円',
    description:
      'グローバル戦略で経営層の課題解決を支える立案と実行支援を担うコンサル業務全般'
  },
  {
    id: 43,
    segment: 'コンサル',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/20.png',
    company: 'ベイカレント',
    position: 'コンサルタント',
    salary: '応相談',
    description:
      'クライアントの戦略・業務・IT課題の抽出から解決策提示実行支援と関係構築業務'
  },
  {
    id: 44,
    segment: 'コンサル',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/21.png',
    company: 'クニエ',
    position: 'DXコンサルタント',
    salary: '応相談',
    description:
      '先端デジタル技術とデータ活用による企業・産業の全方位変革と成長実現DX総合支援'
  },
  {
    id: 45,
    segment: 'コンサル',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/27.png',
    company: '日立コンサルティング',
    position: '製造IT\nコンサルタント',
    salary: '応相談',
    description:
      '製造業のデジタル改革促進　ERP・MES導入上流工程で生産性向上と全体最適支援'
  },
  {
    id: 46,
    segment: 'コンサル',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/607.png',
    company: 'SHIFT',
    position: 'ITコンサルタント',
    salary: '750〜2,000万円',
    description:
      '金融・流通・製造業大手企業向けITプロジェクト上流工程推進及び業務課題解決支援'
  },
  {
    id: 47,
    segment: 'コンサル',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/42.png',
    company: 'フューチャー',
    position: 'プロジェクト\nテクニカルリーダー',
    salary: '550〜1500万円',
    description:
      '顧客戦略に基づく先進技術採用で中立的視点からシステム構築最適化を包括的に推進支援'
  },
  {
    id: 48,
    segment: 'コンサル',
    imageUrl: 'https://storage.googleapis.com/view-dev2-images/logo/32.png',
    company: 'Dirbato',
    position: 'ITコンサルタント',
    salary: '400〜900万円',
    description:
      '大手業界顧客向け、IT戦略立案、DX企画、AI活用、クラウド導入及び業務改革支援'
  }
];

// 各求人をセグメントごとの配列に振り分ける
jobPositionList.forEach(position => {
  if (jobPositionsBySegment[position.segment]) {
    jobPositionsBySegment[position.segment].push(position);
  }
});
